import React, { useState } from 'react';

import StockMobileSidePanel from '@/components/StockMobileSidePanel';
import { RangeOptionType, RangeVariantType } from '@/typings/common';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarEngineCapacity,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  convertFilterParamsToOptionsByKey,
  handleClearRangeSelect,
} from '@/modules/CarsStock/components/common.helpers';
import StockFilterRangeSelect from '@/components/StockFilterRangeSelect';

import {
  FilterButton,
  FilterButtonWrapper,
  MobileFilterItemWrapper,
} from '../../../../../../../common.styles';

function EngineCapacityFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedEngineCapacity =
    useTypedSelector(getSelectedFilters).selectedParams.selectedEngineCapacity;
  const [isOpened, setOpened] = useState(false);

  const handleSidePanelOpen = () => {
    setOpened(true);
  };

  const handleSidePanelClose = () => {
    setOpened(false);
  };

  const engineCapacityOptions = convertFilterParamsToOptionsByKey(
    stockFilterParams,
    'engineVolumes'
  );

  const handleChangeEngineCapacity = (engineCapacity: RangeOptionType) => {
    dispatch(setCarEngineCapacity(engineCapacity));
    dispatch(setPage(1));
  };

  const handleClearEngineCapacity = (type: RangeVariantType) => {
    dispatch(
      setCarEngineCapacity(handleClearRangeSelect(type, selectedEngineCapacity))
    );
    dispatch(setPage(1));
  };

  return (
    <StockMobileSidePanel
      title="Объем двигателя"
      zIndex={10001}
      isInnerSidePanel
      isOpened={isOpened}
      onOpen={handleSidePanelOpen}
      onClose={handleSidePanelClose}
    >
      <MobileFilterItemWrapper>
        <StockFilterRangeSelect
          values={selectedEngineCapacity}
          options={engineCapacityOptions}
          onChange={handleChangeEngineCapacity}
          onClear={handleClearEngineCapacity}
        />
      </MobileFilterItemWrapper>

      <FilterButtonWrapper>
        <FilterButton onClick={handleSidePanelClose}>Применить</FilterButton>
      </FilterButtonWrapper>
    </StockMobileSidePanel>
  );
}

export default EngineCapacityFilter;
